import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { LoggingService } from '../shared/services/logging/logging.service';
import { CategoriesService } from '../shared/category/categories.service';
import { Process } from '../shared';
import * as fromLeaveRequest from '.';
import { processResolver } from '../efaact-routing/process-resolver';

const log = new LoggingService();

export const LeaveRequestRoute: Ng2StateDeclaration = {
    // name: 'LeaveRequest.**'
    name: 'leaverequest',
    url: '/leaverequest',
    // , loadChildren: () => import('./leave-request.module').then(r => r.LeaveRequestModule)
    data: { requiresAuth: true },
    params: { process: {} },
    resolve: [
        {
            token: 'process',
            deps: [Transition, CategoriesService],
            resolveFn: processResolver
        }
    ],
    component: fromLeaveRequest.LeaveRequestFeatureComponent
};

export const LeaveRequestApprovalRoute: Ng2StateDeclaration = {
    name: 'leaverequest.approval',
    url: '/approval',
    // , loadChildren: () => import('./leave-request.module').then(r => r.LeaveRequestModule)
    data: { requiresAuth: true },
    params: { process: {} },
    resolve: [
        {
            token: 'process',
            deps: [Transition, CategoriesService],
            resolveFn: processResolver
        }
    ],
    component: fromLeaveRequest.LeaveRequestFeatureComponent
};
